/**
 * Clients have no stored colour, so one is derived from the id: stable across
 * screens and sessions, and the same dot in the picker as the bar in the day
 * list. Palette and pairs from the design canvas (Main.dc.html).
 */
const PALETTE = [
  { dot: '#4f46e5', bg: '#e0e7ff', fg: '#4338ca', darkBg: '#1e1b4b', darkFg: '#a5b4fc' },
  { dot: '#10b981', bg: '#dcfce7', fg: '#047857', darkBg: '#022c22', darkFg: '#6ee7b7' },
  { dot: '#f59e0b', bg: '#fef3c7', fg: '#b45309', darkBg: '#422006', darkFg: '#fcd34d' },
  { dot: '#ec4899', bg: '#fce7f3', fg: '#be185d', darkBg: '#500724', darkFg: '#f9a8d4' },
  { dot: '#0ea5e9', bg: '#e0f2fe', fg: '#0369a1', darkBg: '#082f49', darkFg: '#7dd3fc' },
  { dot: '#8b5cf6', bg: '#ede9fe', fg: '#6d28d9', darkBg: '#2e1065', darkFg: '#c4b5fd' },
  { dot: '#f43f5e', bg: '#ffe4e6', fg: '#be123c', darkBg: '#4c0519', darkFg: '#fda4af' },
  { dot: '#14b8a6', bg: '#ccfbf1', fg: '#0f766e', darkBg: '#042f2e', darkFg: '#5eead4' }
];

function hash(s: string) {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0;
  return Math.abs(h);
}

export function clientColor(id: string | null | undefined) {
  return PALETTE[hash(id ?? '') % PALETTE.length]!;
}

export function initialsOf(name: string | null | undefined) {
  const words = (name ?? '').replace(/[^\p{L}\p{N}\s&]/gu, '').split(/\s+/).filter((w) => w && w !== '&');
  return ((words[0]?.[0] ?? '?') + (words[1]?.[0] ?? '')).toUpperCase();
}
